import styled from 'styled-components';

type Props = {
  vin: string;
};

export const Vin = ({ vin }: Props) => {
  return (
    <VinContainer className="mr-1">
      {vin.substr(0, vin.length - 8)}
      <b>{vin.substr(vin.length - 8)}</b>
    </VinContainer>
  );
};

const VinContainer = styled.label`
  white-space: nowrap;
  text-transform: uppercase;
`;
